module.exports = __webpack_public_path__ + "img/yo.e3118b4e.svg";